import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || currentYear,
            month: filters.month?.value,
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankPoliceStationElaboration = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_POLICE_STATION_ELABORATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/byPoliceStationElaboration'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/byDepartment'
        },
        filterParams
    );

    const rankByDepartmentElaboration = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_POLICE_BY_DEPARTMENT_ELABORATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/byDepartmentElaboration'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/bySectional'
        },
        filterParams
    );

    const rankBySectionalElaboration = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_RANKINGS_SECTIONAL_ELABORATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/bySectionalElaboration'
        },
        filterParams
    );

    const rankByMunicipalityElaboration = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.POLICE_INTERVENTION_DEATHS_RANKINGS_MUNICIPALITY_ELABORATION,
            url: 'governanceroom/securitydashboard/deathsByPoliceIntervention/rankings/byMunicipalityElaboration'
        },
        filterParams
    );

    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byMunicipalityElaboration: rankByMunicipalityElaboration.data || [],
        byPoliceStationElaboration: rankPoliceStationElaboration.data || [],
        byDepartmentElaboration: rankByDepartmentElaboration.data || [],
        rankBySectionalElaboration: rankBySectionalElaboration.data || []
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
